import tenantConfig from '../tenant.config';

export default {
  legacy: false,
  fallbackLocale: tenantConfig.fallbackLocale || tenantConfig.defaultLocale,
};